import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';

const assetReportAdTypeFilter = items => _.reduce(items, (result, item) => {
  // eslint-disable-next-line no-param-reassign
  item.children = assetReportAdTypeFilter(item.children);
  if (item.id !== 'combinations') {
    result.push(item);
  }
  return result;
}, []);

export function processAssetReportAdType(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const { scope } = props;

    if (scope && scope.values &&
      ((scope.values.adType === 'DynamicSearch' || scope.values.adType === 'DynamicResponsive')
        || scope.values.campaignType === 'Audience')) {
      const processedSiteMap = assetReportAdTypeFilter(siteMap);
      return (<Component {...props} siteMap={processedSiteMap} />);
    }
    return <Component {...props} siteMap={siteMap} />;
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return withScope(Wrapper);
}
